import React from "react";
import PropTypes from "prop-types";
import { Auth } from 'aws-amplify';

// material-ui components
import withStyles from "material-ui/styles/withStyles";

import Contacts from "@material-ui/icons/Contacts";
//import Check from "@material-ui/icons/Check";


// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import ItemGrid from "components/Grid/ItemGrid.jsx";
//import RegularCard from "components/Cards/RegularCard.jsx";
import IconCard from "components/Cards/IconCard.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import UserNotifications from "components/UserNotifications/UserNotifications.jsx";


import registerPageStyle from "assets/jss/material-dashboard-pro-react/views/registerPageStyle";

class VerificationPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      usernameSet: false,
      notification: false,
      notifications:[],
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSubmitUsername = this.handleSubmitUsername.bind(this);
    this.handleInput = this.handleInput.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }
  handleSubmit(event){
    event.preventDefault();

    const { username, code} = this.state;

    // Collect confirmation code, then
    Auth.confirmSignUp(username, code)
        .then(data => {
          this.props.history.push({pathname:"/login", state:this.state});

        })
        .catch(err => {
          var message = err.message?err.message:err;
          var error = {color:"warning", state:true,  message:message};
          this.setState({notification:true,  notifications:[error]});
        });
  }

  handleResend(event){
    event.preventDefault();

    const { username } = this.state;

    // Collect confirmation code, then
    Auth.resendSignUp(username)
        .then(data => {
          var error = {color:"info", state:true, message:"We've just sent you another verification code to your email address."};
          this.setState({notification:true,  notifications:[error]});
        })
        .catch(err => {
          var error = {color:"warning", state:true, message:err.message};
          this.setState({notification:true,  notifications:[error]});
        });

  }
  
  componentDidMount() {

    if(this.props.location.state.username){
      this.setState({username:this.props.location.state.username, usernameSet:true});
    }

    if(this.props.location.state.email){
      this.setState({email:this.props.location.state.email});
    }
    
  }

  handleSubmitUsername(e){
    this.setState({ usernameSet: true });
  }
  handleCancel(e){
    this.setState({ usernameSet: false, username: false });
  }

  handleInput(e){
    this.setState({ [e.target.name]: e.target.value });
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          <UserNotifications 
            notification={this.state.notification} 
            notifications={this.state.notifications} 
            onClose={() => this.setState({ notification: false })} 
          /> 
          <ItemGrid xs={12} sm={6} md={4}>
            <IconCard
              icon={Contacts}
              iconColor="rose"
              title="Account Verification"
                content={
                        <form className={classes.form}>

                        {this.state.email?(<p>We've just sent a verification code to <strong>{this.state.email}</strong>.</p>):""}

                         {!this.state.usernameSet?(
                            <div>
                            <CustomInput
                              formControlProps={{
                                fullWidth: true,
                                className: classes.customFormControlClasses
                              }}
                              inputProps={{
                                placeholder: "Username...",
                                onChange: this.handleInput,
                                name: "username",  
                              }}
                            />
                            <Button round color="primary" onClick={(e) => this.handleSubmitUsername(e)} >Ok</Button>
                            </div>
                          ):(
                          <div>
                            <span>Username:&nbsp;</span><strong>{this.state.username}</strong>
                            <CustomInput
                              formControlProps={{
                                fullWidth: true,
                                className: classes.customFormControlClasses
                              }}
                              inputProps={{
                                placeholder: "Verification Code...",
                                onChange: this.handleInput,
                                name: "code",                          
                              }}
                            />
                            <div className={classes.center}>
                              <Button round color="primary" onClick={(e) => this.handleSubmit(e)} >Go</Button>
                              <Button round color="primaryNoBackground" onClick={(e) => this.handleResend(e)} >Resend</Button>
                              <Button round color="primaryNoBackground" onClick={(e) => this.handleCancel(e)} >Cancel</Button>
                            </div>
                          </div>
                          )}
                        </form>
                }
              />
          </ItemGrid>
        </GridContainer>
      </div>
    );
  }
}

VerificationPage.propTypes = {
  classes: PropTypes.object.isRequired,
  error: PropTypes.string,  
};

export default withStyles(registerPageStyle)(VerificationPage);



// WEBPACK FOOTER //
// ./src/views/User/VerificationPage.jsx